<script setup>
import { ArrowRight16 } from '@carbon/icons-vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from 'dashboard/components-next/polaris/ui/card';

// Rebuilt inside on the kit's AssignmentChoiceCard (phase 9.8): the whole card is one action — its title is the
// button, stretched over the card, so it is one stop for the keyboard. Same props and `click` event.
defineProps({
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  features: { type: Array, default: () => [] },
});

const emit = defineEmits(['click']);
</script>

<template>
  <Card
    class="relative gap-3 py-4 transition-colors hover:bg-polaris-accent has-[:focus-visible]:ring-[3px] has-[:focus-visible]:ring-polaris-ring/50"
    data-choice-card
  >
    <CardHeader class="px-4">
      <CardTitle>
        <button
          type="button"
          class="flex items-center gap-2 p-0 text-start outline-none after:absolute after:inset-0 after:rounded-polaris-xl after:content-['']"
          @click="emit('click')"
        >
          {{ title }}
          <ArrowRight16 class="size-4 rtl:rotate-180" aria-hidden="true" />
        </button>
      </CardTitle>
      <CardDescription>{{ description }}</CardDescription>
    </CardHeader>
    <CardContent class="px-4">
      <ul role="list" class="m-0 grid list-none gap-1.5 p-0">
        <li
          v-for="feature in features"
          :key="feature.id"
          class="flex items-center gap-2 type-polaris-body"
        >
          <Icon
            :icon="feature.icon"
            class="size-4 shrink-0 text-polaris-muted-foreground"
          />
          {{ feature.label }}
        </li>
      </ul>
    </CardContent>
  </Card>
</template>
